import { CdkVirtualForOf, CdkVirtualScrollViewport, ScrollingModule } from '@angular/cdk/scrolling';
import { Component, input, output } from '@angular/core';

import { PrivaTitleComponent } from '@priva/components/title';
import { PrivaLocalizationModule } from '@priva/localization';

import { TileListUtils } from 'app/shared/components/tile-list/tile-list.utils';

import { GroupTilesPipe } from './group-tiles.pipe';
import { Tile, TileDivider } from './models';
import { TileComponent } from './tile/tile.component';

@Component({
    selector: 'app-tile-list',
    templateUrl: './tile-list.component.html',
    styleUrl: './tile-list.component.scss',
    imports: [
        CdkVirtualForOf,
        CdkVirtualScrollViewport,
        ScrollingModule,
        PrivaLocalizationModule,
        PrivaTitleComponent,
        GroupTilesPipe,
        TileComponent,
    ],
})
export class TileListComponent {
    tiles = input<any>([]);

    tileClick = output<any>();

    tileListUtils = TileListUtils;

    onTileClick(tile: any): void {
        if (tile?.isSeparator) {
            return;
        }

        this.tileClick.emit(tile);
    }

    get hasTiles(): boolean {
        return this.tiles().length > 0;
    }

    trackByFn(index: number, item: any) {
        return item;
    }

    protected isDividerTile(tile: Tile | TileDivider): tile is TileDivider {
        return Boolean(tile?.dividerText);
    }
}
